/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbSharedRefineMenuTypeaheadContainer_itemSearch$ref = any;
export type SbSharedRefineMenuTypeaheadContainer_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly clearAllLinkReference: string | null;
    } | null> | null;
    readonly " $refType": SbSharedRefineMenuTypeaheadContainer_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuTypeaheadContainer_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "topCategoryL1",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "appliedFilters",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseParsedParam",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clearAllLinkReference",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '8b14178c100aca97ad632f33c5e1606e';
export default node;
